import { render, staticRenderFns } from "./PlantInfoMetric.vue?vue&type=template&id=8ef8b5e0"
import script from "./PlantInfoMetric.vue?vue&type=script&lang=ts"
export * from "./PlantInfoMetric.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports